import Vue from 'vue'
const CryptoJS = require('crypto-js')
import {PDFJS} from 'pdfjs-dist'
PDFJS.workerSrc = require('pdfjs-dist/build/pdf.worker')
PDFJS.cMapUrl = process.env.BASE_URL + 'static/cmaps/'
PDFJS.cMapPacked = true

export default {
  data () {
    return {
      fileHash: ''
    }
  },
  created () {
  },
  methods: {
    loadFiles () {
      for (var i = 0; i < this.files.length; i++) {
        this.loadFile(i)
      }
    },
    // 加载pdf文件
    loadFile (fileIndex) {
      return new Promise((resolve, reject) => {
        if (fileIndex >= this.files.length) {
          return
        }
        var file = this.files[fileIndex];
        PDFJS.getDocument(file.fileUrl).then((pdf) => {
          // 文件hash
          file.fileHash = pdf.fingerprint;
          // 文件已加载
          file.loaded = true;
          // 文件页数
          file.totalPage = pdf.numPages
          // pdf文档
          file.pdf = pdf
          this.getAllFileHash()
          // 先渲染第一个文件
          if (fileIndex == 0) {
            // 加载完成之后，渲染第一页
            this.renderPage(fileIndex,0)
          }
        })
      })
    },
    getAllFileHash() {
      let strs = []
      let flag = false
      for (var i = 0; i < this.files.length; i++) {
        var file = this.files[i]
        if (!file.fileHash) {
          flag = true
          break
        }
        strs.push(file.fileHash)
      }
      if (!flag) {
        this.fileHash = CryptoJS.MD5(strs.join(',').toUpperCase()).toString().toUpperCase()
        console.log(this.fileHash)
      }
    },
    // 渲染pdf
    renderPage (fileIndex, pageIndex) {
      var file = this.files[fileIndex]
      if (!file.loaded) {
        // 如果文件没有加载完成，等待文件加载完成
        setTimeout(() => {
          this.renderPage(fileIndex, pageIndex)
        },10);
        return
      }
      var totalPage = file.totalPage

      var width = document.getElementById('0-0').offsetWidth
      file.pdf.getPage(pageIndex+1).then((page) => {

        var t1 = new Date().getTime()

        var viewport = page.getViewport(1)

        // 文字fontScale
        Vue.set(this.fs, fileIndex + '-' + pageIndex, width / viewport.width)
        // 签名和印章宽度
        Vue.set(this.ws, fileIndex + '-' + pageIndex, 120/viewport.width)

        var scale = Math.max(width / viewport.width, 1)
        viewport = page.getViewport(scale)
        var canvas = document.getElementById('pdf-' + fileIndex + '-' + pageIndex)
        if (canvas) {
          var context = canvas.getContext('2d')

          canvas.width = viewport.width
          canvas.height = viewport.height

          canvas.style.width = width + 'px'
          canvas.style.height = width * viewport.height / viewport.width + 'px'

          var renderContext = {
            canvasContext: context,
            viewport: viewport
          }
          page.render(renderContext).then(() => {
            var t2 = new Date().getTime()
            console.log('render pdf ' ,fileIndex ,pageIndex, (t2 - t1) + 'ms')

            this.renderThumb(fileIndex, pageIndex)
            Vue.set(this.loading, fileIndex + '-' + pageIndex, true)
          })
        }
        if (pageIndex < totalPage - 1) {
          setTimeout(() => {
            this.renderPage(fileIndex, pageIndex + 1)
          }, 10)
        } else {
          // 当前文件已经渲染完，即将进行下一个文件的渲染
          var nextFileIndex = fileIndex + 1
          if (nextFileIndex < this.files.length) {
            this.renderPage(nextFileIndex, 0)
          }
        }
      })
    },
    // 渲染缩略图
    renderThumb (fileIndex, pageIndex) {
      var pdfId = 'pdf-' + fileIndex + '-' + pageIndex
      var thumbId = 'thumb-' + fileIndex + '-' + pageIndex
      var oldCanvas = document.getElementById(pdfId);
      var newCanvas = document.getElementById(thumbId);
      if (newCanvas) {
        var context = newCanvas.getContext('2d');
        newCanvas.height = newCanvas.width * oldCanvas.height / oldCanvas.width;

        context.clearRect(0, 0, newCanvas.width, newCanvas.height);
        context.drawImage(oldCanvas, 0, 0, newCanvas.width, newCanvas.height);
      }
    }
  }
}
